import resourceLocales from './locales';
import resourceConfig from './config';
import Button from './DocUpdateButton';

export default {
  Button,
  name: resourceConfig.name,
  locales:  resourceLocales,
}